/* eslint-disable @typescript-eslint/no-empty-function */
import React, { PropsWithChildren, useState } from 'react';
import { CircularProgress, Modal } from '@mui/material';
import styled from '@emotion/styled';

interface LoadingScreenContextInterface {
  loading: boolean;
  setLoading: (value: boolean) => void;
}

const defaultLoadingContext: LoadingScreenContextInterface = {
  loading: false,
  setLoading: () => null,
};

export const LoadingScreenContext =
  React.createContext<LoadingScreenContextInterface>(defaultLoadingContext);

const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
`;

export const LoadingScreenProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [loading, setLoading] = useState<boolean>(
    defaultLoadingContext.loading
  );

  return (
    <LoadingScreenContext.Provider
      value={{
        loading,
        setLoading,
      }}>
      {children}
      <Modal open={loading} disableAutoFocus={true} disableEnforceFocus={true}>
        <StyledCircularProgress />
      </Modal>
    </LoadingScreenContext.Provider>
  );
};
